import { render, staticRenderFns } from "./import-entities-optimized.vue?vue&type=template&id=2c27796e&scoped=true"
import script from "./import-entities-optimized.vue?vue&type=script&lang=js"
export * from "./import-entities-optimized.vue?vue&type=script&lang=js"
import style0 from "./import-entities-optimized.vue?vue&type=style&index=0&id=2c27796e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27796e",
  null
  
)

export default component.exports